import { PATH_SIGNUP_ME } from '@farmersdog/constants/paths';
import { getLinkToFreshSignup } from '@farmersdog/tosa/src/utils/getLinkToSignupFlow';
import { GridItem } from '@farmersdog/corgi-x';
import {
  CtaTrackerV2,
  HomepageRedesignSections,
} from '../../../../CtaTrackerV2';
import { ExtendedButton } from '../../../../ExtendedButton';

import styles from './CtaButton.module.css';

export const CtaButton = () => {
  const linkToFreshSignup = getLinkToFreshSignup(PATH_SIGNUP_ME);

  return (
    <GridItem
      className={styles.container}
      justify={{ xs: 'center', lg: 'flex-start' }}
    >
      <CtaTrackerV2
        type="select"
        moduleLevel={1}
        moduleName={HomepageRedesignSections.BowlPack}
      >
        <ExtendedButton
          variant="solid-kale-2"
          type="link"
          to={linkToFreshSignup}
        >
          Make The Switch
        </ExtendedButton>
      </CtaTrackerV2>
    </GridItem>
  );
};
